var _rect, _path, _path2, _rect2, _rect3, _rect4, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 16,
    fill: "#DDEBF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 92H82C85.3137 92 88 89.3137 88 86V44L72 28H38C34.6863 28 32 30.6863 32 34V86C32 89.3137 34.6863 92 38 92Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28L79.5 35.5L88 44H80C75.5817 44 72 40.4183 72 36V28Z",
    fill: "#9BC6F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 57,
    width: 32,
    height: 3,
    rx: 1.5,
    fill: "#9BC6F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 48,
    width: 32,
    height: 3,
    rx: 1.5,
    fill: "#9BC6F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 66,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "#9BC6F0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 83,
    r: 15,
    fill: "#0083FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 86.0688V79.9312C80 79.2222 80.7221 78.774 81.3096 79.1183L86.5466 82.1872C87.1511 82.5415 87.1511 83.4585 86.5466 83.8128L81.3096 86.8817C80.7221 87.226 80 86.7778 80 86.0688Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateResume);
export default __webpack_public_path__ + "static/media/createResume.d7fc8c85.svg";
export { ForwardRef as ReactComponent };